<template>
  <div
    style="
      display: flex;
      height: 100%;
      overflow: hidden;
      padding: 0 20px 0 10px;
    "
  >
    <div class="flex flex-column" style="flex: 2; overflow-y: auto">
      <div
        style="
          font-size: 13px;
          font-weight: 600;
          margin: 10px;
          border-bottom: 1px solid #e2e2e2;
          padding-bottom: 10px;
        "
      >
        基本信息
      </div>
      <table class="invoice-detail-record-table" cellpadding="10">
        <tr>
          <td>状态</td>
          <td>
            <c_status
              v-if="
                state.model?.status != null && state.model?.status != undefined
              "
              arr-name="invoice_status"
              :value="state.model?.status"
            ></c_status>
          </td>
          <td>客户名称</td>
          <td>{{ state.model.customer_name }}</td>
        </tr>
        <tr>
          <td>发票类型</td>
          <td>{{ state.model.d_invoice_name }}</td>
          <td>发票抬头</td>
          <td>{{ state.model.title }}</td>
          <td>统一社会信用代码</td>
          <td>{{ state.model.s_unified_social_credit_identifier }}</td>
        </tr>
        <tr>
          <td>开票类型</td>
          <td>{{ state.model.d_invoice_type_name || "-" }}</td>
          <td>开票信息</td>
          <td>
            {{ state.model.invoice_nature == 0 ? "普通发票" : "增值税发票" }}
          </td>
          <td>开票种类</td>
          <td>{{ state.model.d_invoice_kind_name || "-" }}</td>
        </tr>
        <tr>
          <td>联系电话</td>
          <td>{{ state.model.contact_phone }}</td>
          <td>开票金额</td>
          <td colspan="2"><c_money :value="state.model?.amount" /></td>
        </tr>
        <tr>
          <td>申请说明</td>
          <td colspan="5">{{ state.model.invoice_remark || "-" }}</td>
        </tr>
      </table>
      <div
        style="
          font-size: 13px;
          font-weight: 600;
          margin: 10px;
          border-bottom: 1px solid #e2e2e2;
          padding-bottom: 10px;
        "
      >
        开票日志
      </div>
      <div style="padding: 0 20px">
        <el-table
          ref="tableDom"
          :data="state.logData"
          v-loading="!Array.isArray(state.logData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
        >
          <el-table-column
            fixed
            label="序号"
            width="70"
            type="index"
            align="center"
          />
          <el-table-column
            label="操作时间"
            prop="update_time"
            width="200"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            prop="remark"
            label="备注"
            :formatter="$tab_ShowToolTip"
            :min-width="150"
          />
          <el-table-column
            prop="content"
            label="内容"
            :formatter="$tab_ShowToolTip"
            :min-width="350"
          />
          <el-table-column label="操作人" width="200">
            <template #default="{ row }">
              <text>{{ row.add_admin_name }}</text>
              <text>{{ "/" + row.add_department_name }}</text>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div style="flex: 1" v-if="state.model.status == 0">
      <div
        style="
          font-size: 13px;
          font-weight: 600;
          margin: 10px;
          border-bottom: 1px solid #e2e2e2;
          padding-bottom: 10px;
        "
      >
        开票操作
      </div>
      <el-form :model="state.checkModel" ref="formDom" style="width: 100%">
        <el-form-item label="审核状态">
          <el-radio-group v-model="state.checkModel.status">
            <el-radio :label="true">开票通过</el-radio>
            <el-radio :label="false">开票驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="state.checkModel.status">
          <el-form-item
            label="发票号"
            prop="invoice_number"
            :rules="[
              { required: true, message: '请填写发票号', trigger: 'blur' },
            ]"
            v-if="state.checkModel.status"
          >
            <el-input v-model="state.checkModel.invoice_number"></el-input>
          </el-form-item>
          <el-form-item
            label="开票日期"
            prop="invoice_date"
            :rules="[
              { required: true, message: '请选择开票日期', trigger: 'blur' },
            ]"
            v-if="state.checkModel.status"
          >
            <el-date-picker
              v-model="state.checkModel.invoice_date"
              type="date"
              placeholder="开票日期"
              value-format="YYYY-MM-DD"
            />
          </el-form-item>
          <el-form-item
            label="开票备注"
            prop="check_remark"
            :rules="[
              { required: true, message: '请填写开票备注', trigger: 'blur' },
            ]"
            v-if="state.checkModel.status"
          >
            <el-input
              type="textarea"
              v-model="state.checkModel.check_remark"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="盖章附件"
            prop="files"
            :rules="[
              { required: true, message: '请上传盖章附件', trigger: 'blur' },
            ]"
            v-if="state.checkModel.status"
          >
            <el-upload
              :show-file-list="false"
              :auto-upload="false"
              :multiple="true"
              :on-change="onChangeFile"
            >
              <template #trigger>
                <el-button type="primary" size="small">上传</el-button>
              </template>
            </el-upload>
            <div style="text-align: center; color: #a2a2a2; padding: 0 10px">
              请点击"上传"按钮上传相关文件~
            </div>
            <div style="width: 100%; padding: 0 10px">
              <ul
                v-for="(item, index) in state.checkModel.files"
                :key="item"
                class="diffbank-detail-files"
              >
                <li style="flex: 1">{{ item.origin_filename }}</li>
                <el-icon
                  @click="state.checkModel.files.splice(index, 1)"
                  color="#f00"
                  ><CloseBold
                /></el-icon>
              </ul>
            </div>
          </el-form-item>
        </template>
        <el-form-item
          label="开票备注"
          prop="check_remark"
          :rules="[
            { required: true, message: '请填写开票备注', trigger: 'blur' },
          ]"
          v-else
        >
          <el-input
            type="textarea"
            v-model="state.checkModel.check_remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="display: flex; justify-content: flex-end">
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </div>
    </div>
    <div style="flex: 1" v-else>
      <div
        style="
          font-size: 13px;
          font-weight: 600;
          margin: 10px;
          border-bottom: 1px solid #e2e2e2;
          padding-bottom: 10px;
        "
      >
        审核信息
      </div>
      <el-form :model="state.model" ref="formDom" style="margin-left: 20px">
        <el-form-item label="审核状态">
          <c_status
            arrName="invoice_status"
            :value="state.model.status"
            v-if="state.model.id"
          />
        </el-form-item>
        <template v-if="state.model.status == 1">
          <el-form-item label="发票号">
            {{ state.model.invoice_number }}
          </el-form-item>
          <el-form-item label="开票日期">
            {{ state.model.invoice_date }}
          </el-form-item>
          <el-form-item label="开票备注">
            {{ state.model.check_remark || "-" }}
          </el-form-item>
          <el-form-item label="附件2">
            <div style="width: 100%">
              <ul
                v-for="item in state.model.invoice_attachment"
                :key="item"
                class="diffbank-detail-files"
              >
                <li
                  style="color: #1e90ff; text-decoration: underline"
                  @click="toFile(item)"
                >
                  {{ item.filename }}
                </li>
              </ul>
            </div>
          </el-form-item>
        </template>
        <el-form-item label="开票备注" v-else-if="state.model.status == 2">
          {{ state.model.check_remark || "-" }}
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  invoice_detail,
  invoice_log,
  invoice_pass,
  invoice_reject,
} from "@/http/invoice";
import { attachment_upload } from "@/http/attachment";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
      files: [],
      checkModel: {
        status: true,
        files: [],
      },
    });
    onMounted(() => {
      if (props.id) {
        state.checkModel.id = props.id;
        onLoad();
      }
    });

    const onLoad = () => {
      invoice_detail(props.id).then((res) => {
        if (res.status == 200) {
          state.model = res.data.data;
        }
      });

      invoice_log(props.id).then((res) => {
        if (res.status == 200) {
          state.logData = res.data.data?.list;
        }
      });
    };

    const onChangeFile = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          res.data.data.forEach((e) => {
            state.checkModel.files.push(e);
          });
        }
      });
    };

    const toFile = (item) => {
      window.open(item.file_url, "_blank");
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          state.checkModel.invoice_attachment = state.checkModel.files
            .map((m) => m.id)
            .join(",");
          ElMessageBox.confirm(
            `您确定<strong style='font-size:16px;font-weight:600;color:${
              state.checkModel.status ? "#080" : "#f00"
            }'>${
              state.checkModel.status ? "同意" : "驳回"
            }</strong>此开票申请？`,
            "开票审核",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              dangerouslyUseHTMLString: true,
              type: "warning",
            }
          ).then(() => {
            if (state.checkModel.status) {
              invoice_pass(state.checkModel).then((res) => {
                if (res.status == 200) {
                  ElMessage.success(res.data.msg);
                  emit("close");
                }
              });
            } else {
              invoice_reject(state.checkModel).then((res) => {
                if (res.status == 200) {
                  ElMessage.success(res.data.msg);
                  emit("close");
                }
              });
            }
          });
        }
      });
    };
    return { state, onChangeFile, formDom, onSubmit, toFile };
  },
};
</script>
<style scoped lang="less">
.invoice-detail-record-table {
  width: 100%;
  font-size: 14px;

  & > tr > td:first-child {
    width: 100px;
  }

  & td:nth-child(2n + 1) {
    color: #a2a2a2;
    text-align: right;
  }

  & td:nth-child(2n) {
    text-align: left;
  }
}

.diffbank-detail-files {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.7);

  &:hover {
    color: #a2a2a2;
  }
}
</style>
